import { makeQuery } from '../types';

type Input = { coupon: string };
type Output = { getEmailRelatedWithCouponCode: string };

export const getEmailRelatedWithCouponCode = makeQuery<Output, Input>(`
query GetEmailRelatedWithCouponCode($coupon: String!) {
  ayn {
    getEmailRelatedWithCouponCode(coupon: $coupon)
  }
}
`);
